export const UPDATE_MERCHANT_ID = 'UPDATE_MERCHANT_ID';
export const FETCH_WALLET_HISTORY_LOG = 'FETCH_WALLET_HISTORY_LOG';
export const UPDATE_WALLLET_HISTORY_PAGINATION = 'UPDATE_WALLLET_HISTORY_PAGINATION';
export const UPDATE_WALLLET_HISTORY_FILTERS = 'UPDATE_WALLLET_HISTORY_FILTERS';
export const WALLET_HISTORY_ASYNC_START = 'WALLET_HISTORY_ASYNC_START';
